import type { Pair } from '../messages';

/** Shared component chrome: dialogs, toasts, loading and error states, the follow button. */
export const ui = {
  'ui.loading': ['Загружаем данные', 'Loading'],
  'ui.loadingShort': ['Загружаем…', 'Loading…'],
  'ui.loadError': ['Не удалось загрузить данные.', 'We couldn’t load this.'],
  'ui.errorTitle': ['Что-то пошло не так', 'Something went wrong'],
  'ui.close': ['Закрыть', 'Close'],
  'ui.closeToast': ['Закрыть уведомление', 'Dismiss notification'],
  'ui.notifications': ['Уведомления', 'Notifications'],
  'ui.delete': ['Удалить', 'Delete'],
  'ui.cancel': ['Отмена', 'Cancel'],
  'ui.waiting': ['Подождите…', 'One moment…'],
  'ui.irreversible': ['Это действие нельзя отменить.', 'This can’t be undone.'],
  'ui.retry': ['Попробовать снова', 'Try again'],
  'ui.follow': ['Подписаться', 'Follow'],
  'ui.following': ['Вы подписаны', 'Following'],
  'ui.followingHint': ['Вы подписаны — новые подборки появятся в ленте', 'Subscribed — new collections appear in your feed'],
} satisfies Record<string, Pair>;
